import { Component, ElementRef, OnInit, ViewChild, Input } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DataService } from '../../../services/data.service';
import { ManageReportService } from '../../../services/manage-report.service';
import { InfoModalComponent } from '../info-modal/info-modal.component';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Layers, LayerUiModel } from './layer.ui.model';
import { LayerModel } from "../../../services/model/ui/layer.ui.model";
import { UserService } from 'src/app/services/user.service';
import { timingSafeEqual } from 'crypto';

@Component({
  selector: 'app-new-layer',
  templateUrl: './new-layer.component.html',
  styleUrls: ['./new-layer.component.scss']
})
export class NewLayerComponent implements OnInit {
  private formData = new FormData();
  // public mode:string = "view";
  // public checkedImgs = [];
  public isAdding: boolean = false;
  // public overLimit:boolean = false;

  public layers: Array<LayerUiModel> = [];
  public color;
  public layer: any = null;
  public projectId;
  public layerId;

  public layerData: LayerModel = {
    project_id: null,
    layer_id: null,
    name: null,
    default_geom_type: null,
    default_entity_type: "COMMON",
    public_layer: true,
    visible_in_sub_projects: true,
    default_visible: true,
    style_descriptor: {
      style_point: {
        icon: null,
        size: 32.0,
        anchor: {
          t1: 16.0,
          t2: 32.0
        }
      },
      style_line: {
        color: "#FF0000",
        opacity: 0.8,
        size: 1.5
      },
      style_polygon: {
        color: "#0000FF",
        fillColor: "#9696FF",
        opacity: 0.8,
        fillOpacity: 0.5,
        size: 1.5
      },
    }
  };

  public layerTypes = [
    {
      key: 'Points',
      value: 'PUNTAL'
    },
    {
      key: 'Lines',
      value: 'LINEAL'
    },
    {
      key: 'Polygon',
      value: 'POLYGONAL'
    }
  ];

  isProceed: boolean = false;
  proceedText: string;

  @ViewChild('file', { static: false }) public file: ElementRef;

  newLayerForm: FormGroup;

  constructor(
    public activeModal: NgbActiveModal,
    private service: DataService,
    private reportService: ManageReportService,
    private modalService: NgbModal,
    private userService: UserService,
    private dataService: DataService,
    public fb: FormBuilder
  ) {
  }

  ngOnInit() {
    this.layers = Layers.get();
    this.newLayerForm = this.fb.group({
      layerName: ['', Validators.required],
      publicLayerVisible: [true, Validators.required],
      defaultVisible: [true, Validators.required],
      visibleInSubProject: [true, Validators.required],
      layerType: ['', Validators.required],
    });

    if (this.layer) {

      this.projectId = this.layer.projectId;
      this.layerId = this.layer.layerId;

      this.layerData.default_visible = this.layer.defaultVisible;
      this.layerData.visible_in_sub_projects = this.layer.visibleinSubProjects;
      this.layerData.public_layer = this.layer.publicLayer;

      this.layerData.default_geom_type = this.layer.geomType.toUpperCase();
      if (this.layer.geomType == 'puntal') {
        this.layerData.style_descriptor.style_point.icon = this.layer.icon;
      }
      else if (this.layer.geomType == 'lineal') {
        this.layerData.style_descriptor.style_line.color = this.layer.line;
      }
      else if (this.layer.geomType == 'polygonal') {
        this.layerData.style_descriptor.style_polygon.color = this.layer.line;
      }
      this.newLayerForm.setValue({
        layerName: this.layer.label,
        layerType: this.layer.geomType,
        publicLayerVisible: this.layer.publicLayer,
        defaultVisible: this.layer.defaultVisible,
        visibleInSubProject: this.layer.visibleinSubProjects
      });
    }
    else {
      this.projectId = this.userService.project.projectID.id;
    }
  }

  layerTypeChange(val) {
    this.layerData.default_geom_type = val;
  }

  layerIconChange(val) {
    this.layerData.style_descriptor.style_point.icon = `${val}.png`;
  }

  save() {
    this.layerData.project_id = this.projectId;
    this.layerData.name = this.newLayerForm.controls['layerName'].value;
    this.isProceed = true;
    if (this.layer) {
      this.proceedText = 'Layer Updating';
      this.layerData.layer_id = this.layerId;
      this.dataService.updateLayerEntity(this.layerData).pipe().subscribe(
        e => {
          this.isProceed = false;
          this.activeModal.close();
          console.log(e);
        }
      );
    }
    else {
      this.proceedText = 'Layer Creating';
      this.dataService.createNewLayer(this.layerData).pipe().subscribe(
        e => {
          this.isProceed = false;
          this.activeModal.close();
          console.log(e);
        }
      );
    }
  }

}
